import React, { useState } from "react";
import PropTypes from "prop-types";

import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";

import { withStyles } from "@material-ui/core/styles";

import "./WarningMessage.css";

const styles = theme => ({
  warningWrapper: {
    backgroundColor: theme.palette.error.main,
    flexWrap: "nowrap !important"
  }
});

const WarningMessage = ({
  message,
  closeable,
  closeAction,
  classes,
  ...props
}) => {
  const [showError, setShowError] = useState(true);
  const closeClickAction = closeAction || (() => setShowError(false));

  return (
    showError && (
      <SnackbarContent
        className={classes.warningWrapper}
        elevation={2}
        message={
          <span className="warning-message">
            <WarningIcon className="warning-icon" />
            {message}
          </span>
        }
        action={
          closeable && [
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={closeClickAction}
            >
              <CloseIcon />
            </IconButton>
          ]
        }
        {...props}
      />
    )
  );
};

WarningMessage.propTypes = {
  message: PropTypes.string,
  closeable: PropTypes.bool,
  closeAction: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  classes: PropTypes.shape()
};

WarningMessage.defaultProps = {
  message: "Oops! A technical error has happened.",
  closeable: true,
  closeAction: undefined
};

export default withStyles(styles, { withTheme: true })(WarningMessage);
